const API_BASE = '/.netlify/functions';

export async function searchTickers(query) {
  const res = await fetch(`${API_BASE}/stocks?action=search&query=${encodeURIComponent(query)}`);
  if (!res.ok) throw new Error('Failed to search tickers');
  return res.json();
}

export async function getPrice(ticker) {
  const res = await fetch(`${API_BASE}/stocks?action=price&ticker=${encodeURIComponent(ticker)}`);
  if (!res.ok) throw new Error('Failed to get price');
  return res.json();
}

export async function getPrices(tickers) {
  const res = await fetch(`${API_BASE}/stocks?action=prices&tickers=${encodeURIComponent(tickers.join(','))}`);
  if (!res.ok) throw new Error('Failed to get prices');
  return res.json();
}

export async function getDetails(ticker) {
  const res = await fetch(`${API_BASE}/stocks?action=details&ticker=${encodeURIComponent(ticker)}`);
  if (!res.ok) throw new Error('Failed to get details');
  return res.json();
}

export async function getAggregates(ticker, from, to, timespan = 'day', multiplier = 1) {
  const params = new URLSearchParams({ action: 'aggregates', ticker, from, to, timespan, multiplier });
  const res = await fetch(`${API_BASE}/stocks?${params}`);
  if (!res.ok) throw new Error('Failed to get aggregates');
  return res.json();
}
